/* eslint-disable no-magic-numbers, no-else-return */
/* global window */

import * as humps from 'humps';
import _ from 'lodash';

export function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    try {
      return response.json().then((err) => {
        const error = new Error(response.statusText);
        error.response = err;
        throw error;
      });
    } catch (error) {
      const responseError = new Error(response.statusText);
      responseError.response = response;
      throw responseError;
    }
  }
}

export function parseJSON(response) {
  return response.json();
}

export function decamelize(response) {
  return humps.decamelizeKeys(response);
}

export function camelize(response) {
  return humps.camelizeKeys(response);
}

export function createQueryParams(params) {
  const queryParams = [];
  Object.keys(params).forEach(key => {
    if (!params[key]) return;
    queryParams.push(`${_.snakeCase(key)}=${params[key]}`);
  });

  if (queryParams.length > 0) {
    return `${queryParams.join('&')}`;
  }

  return null;
}

export function addQueryParams(path, params) {
  const queryString = createQueryParams(params);
  if (queryString) {
    return `${path}?${queryString}`;
  }

  return path;
}

export function getQueryParams(queryString) {
  const query = (queryString || window.location.search).substring(1); // delete ?
  if (!query) {
    return false;
  }

  const paramsArray = query.split('&')
    .map((params) => {
      const p = params.split('=');

      return [p[0], decodeURIComponent(p[1])];
    });

  const paramsObject = {};
  paramsArray.forEach((value) => {
    paramsObject[value[0]] = value[1];
  });

  return camelize(paramsObject);
}

export function addOrReplaceQueryParams(path, paramsObject) {
  const params = { ...getQueryParams(), ...paramsObject };

  return addQueryParams(path, params);
}
